import React from 'react';
import { assetPrefix } from '../../../utils/assetPrefix';

import { Text } from '../../shared/Text';

export const SurPlusCta = ({ isMobile }: { isMobile?: boolean }) => {

    const { alt, src } = getImageProps();

    return (
        <div
            className={`c-sur-plus-cta`}>
            <Text as="h2">
							Overwaarde huis berekenen
            </Text>
						<Text as="p">
							Meteen zien hoeveel overwaarde je hebt? Bereken nu de huidige overwaarde van je huis met onze rekentool. Hoe meer overwaarde je hebt, hoe meer geld je te besteden hebt bij de aankoop van je nieuwe woning.
						</Text>
            <img className="c-sur-plus-cta__image" alt={alt} src={`${assetPrefix}${src}`} />
        </div>
    );
};

function getImageProps(): { src: string; alt: string } {
	return {
		src: '/assets/img.png',
		alt: 'Overwaarde huis berekenen',
	};
}
